import React from 'react';

import { RangeSlider } from '$partials/filters/individual/range-slider';
import { useAreaUnits } from '$contexts/area-units';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/filters/individual.d.ts').RangeSlider}
 */
export const AreaSlider = ({
    label,
    max = 1,
    min = 0,
    onChange,
    value,
}) => {
    const { unit, convertUnitOfArea } = useAreaUnits() || {};

    const minValue = convertUnitOfArea({ amount: value[0], from: 'sqft', to: unit });
    const minDisplay = `${new Intl.NumberFormat('en-GB', { notation: 'compact' }).format(minValue)} ${unit}`;

    const maxValue = convertUnitOfArea({ amount: value[1], from: 'sqft', to: unit });
    const maxDisplay = `${new Intl.NumberFormat('en-GB', { notation: 'compact' }).format(maxValue)} ${unit}`;

    return (
        <RangeSlider
            label={label}
            max={max}
            maxDisplay={maxDisplay}
            min={min}
            minDisplay={minDisplay}
            name='size'
            onChange={onChange}
            step={1000}
            value={value} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default AreaSlider;
